<template>
  <div class="zoom-box" :style="{ transform: `scale(${this.snum})` }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    snum: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style scoped>
.zoom-box {
  padding: 4rem 0;
  transform-origin: 50% 0px 0px;
}
</style>
